import * as Yup from 'yup';
import { DictionaryDeposit } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryDeposit>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
